module.exports = __webpack_public_path__ + "static/sponsor-uf-health-eb24a2cad34526c72d8b01baab1d3da9.png";